import React from 'react'
import { CircularProgress, makeStyles, styled } from '@material-ui/core'
import { connect } from 'react-redux'

import { roles, accessSocioemotional } from '../utils/constants'
import { useHistory } from 'react-router-dom'
import StyledSVG from '../components/shared/StyledSVG'
import EventCalendar from '../components/calendar/EventCalendar'
import SocioemotionalSlider from '../components/slider/SocioemotionalSlider'
import InfirmarySlider from '../components/slider/InfirmarySlider'
import EventCommentSlider from '../components/slider/EventCommentSlider'
import EventsSlider from '../components/slider/EventsSlider'
import LastMessagesSlider from '../components/slider/LastMessagesSlider'
import Button from '../components/button/Button'

import { useHasAccess } from '../utils/useHasAccess'

import { getHomepageOverviewRSPA } from '../store/users/actions'
import { newGetThemes, newCleanThemes } from '../store/themes/actions'
import { getReportStudentsAnswers } from '../store/reports/actions'
import {
  getEvents,
  getEventComments,
  getEventsRSPA
} from '../store/events/actions'
import { getMessagesWithoutRoomRSPA } from '../store/chats/actions'

import childrensImageVetor from '../assets/homepage-introdution-vector.png'
import homepageAnnouncementsSVG from '../assets/icons/homepage-announcements.svg'
import homepageReportsSVG from '../assets/icons/homepage-reports.svg'
import homepageContentsSVG from '../assets/icons/homepage-contents.svg'
import homepageClassroomsSVG from '../assets/icons/homepage-classrooms.svg'
import homepageEventsSVG from '../assets/icons/homepage-events.svg'
import homepageMessagesSVG from '../assets/icons/homepage-messages.svg'

const ContainerHomePage = styled('div')(({ theme }) => ({
  width: '98%',
  padding: '0px 0px 30px 0px',
  height: 'auto',
  alignContent: 'flex-start',
  fontFamily: 'Montserrat, Source Sans Pro',
  [theme.breakpoints.down('730')]: {
    width: '100%'
  }
}))
const getDesktopAreas = ({ isNurse, isTeacher, isPsychologist }) => {
  if (isNurse) {
    return `
      "welcomeUser                  welcomeUser"
      "informationCards             infirmary"
      "latestComments               latestMessages"
      "digitalMural                 latestMessages"
      "eventsCalendar               eventsCalendar"
    `
  }

  if (isTeacher) {
    return `
      "welcomeUser                  welcomeUser"
      "exploringSocioemotional      exploringSocioemotional"
      "informationCards             latestMessages"
      "digitalMural                 latestMessages"
      "eventsCalendar               eventsCalendar"
    `
  }

  if (isPsychologist || isNurse) {
    return `
      "welcomeUser                  welcomeUser"
      "exploringSocioemotional      exploringSocioemotional"
      "informationCards             infirmary"
      "digitalMural                 latestMessages"
      "digitalMural                 latestMessages"
      "eventsCalendar               eventsCalendar"
    `
  }

  return `
      "welcomeUser                  welcomeUser"
      "exploringSocioemotional      exploringSocioemotional"
      "informationCards             infirmary"
      "latestComments               latestMessages"
      "digitalMural                 latestMessages"
      "eventsCalendar               eventsCalendar"
  `
}

const getMobileAreas = ({ isNurse, isTeacher, isPsychologist }) => {
  if (isNurse) {
    return `
      "welcomeUser"
      "informationCards"
      "infirmary"
      "latestComments"
      "latestMessages"
      "digitalMural"
      "eventsCalendar"
    `
  }

  if (isTeacher) {
    return `
      "welcomeUser"
      "exploringSocioemotional"
      "informationCards"
      "latestMessages"
      "digitalMural"
      "eventsCalendar"
    `
  }

  if (isPsychologist || isNurse) {
    return `
      "welcomeUser"
      "exploringSocioemotional"
      "informationCards"
      "infirmary"
      "latestMessages"
      "digitalMural"
      "eventsCalendar"
    `
  }

  return `
    "welcomeUser"
    "exploringSocioemotional"
    "informationCards"
    "infirmary"
    "latestComments"
    "latestMessages"
    "digitalMural"
    "eventsCalendar"
  `
}

const useStyles = makeStyles(theme => ({
  homepageGrid: props => ({
    display: 'grid',
    gap: 20,
    gridTemplateColumns: '1.9fr 1.2fr',
    gridTemplateAreas: getDesktopAreas(props),

    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: '1fr',
      gridTemplateAreas: getMobileAreas(props)
    }
  }),
  // Grid Areas
  welcomeUser: {
    gridArea: 'welcomeUser',
    minWidth: 0 // em todos os grid areas seguintes essa largura minima precisa ser 0, sem isso, elementos internos com largura fixa forçam overflow e quebram o grid.
  },
  exploringSocioemotional: {
    gridArea: 'exploringSocioemotional',
    minWidth: 0
  },
  informationCards: {
    gridArea: 'informationCards',
    minWidth: 0,
    height: 'auto',
    alignItems: 'center',
    [theme.breakpoints.down('818')]: {
      display: 'flex',
      flexWrap: 'nowrap',
      overflowX: 'auto',
      justifyContent: 'start',
      overflowY: 'hidden',
      alignItems: 'center',
      height: '250px',
      WebkitOverflowScrolling: 'touch'
    }
  },
  infirmary: {
    gridArea: 'infirmary',
    minWidth: 0
  },
  latestComments: {
    gridArea: 'latestComments',
    minWidth: 0
  },
  latestMessages: {
    gridArea: 'latestMessages',
    minWidth: 0
  },
  digitalMural: {
    gridArea: 'digitalMural',
    minWidth: 0
  },
  eventsCalendar: {
    gridArea: 'eventsCalendar',
    minWidth: 0,
    [theme.breakpoints.down(1333)]: {
      overflowX: 'scroll',
      overflowY: 'hidden',
      scrollbarGutter: 'stable',
      WebkitOverflowScrolling: 'touch',
      paddingBottom: 20,
      backgroundColor: '#F5F7FB',
      '&::-webkit-scrollbar': {
        height: 12
      },
      '&::-webkit-scrollbar-track': {
        background: '#E4E9F2',
        borderRadius: 10
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#878787',
        borderRadius: 10
      }
    }
  },
  // end Grid Areas
  content: {
    paddingLeft: 8,
    paddingRight: 8
  },
  first_section: {
    width: '100%',
    minHeight: 270,
    backgroundColor: '#E8E8DB',
    borderRadius: 16,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    backgroundImage: `url(${childrensImageVetor})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    padding: '38px 76px',
    [theme.breakpoints.down('730')]: {
      padding: '0px',
      alignItems: 'center'
    }
  },
  textContent: {
    minWidth: 350,
    maxWidth: 550,
    width: '100%',
    [theme.breakpoints.down('730')]: {
      padding: 20
    },
    [theme.breakpoints.down('500')]: {
      padding: 20,
      minWidth: 300,
      maxWidth: 550,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    },
    [theme.breakpoints.down('340')]: {
      padding: 5
    }
  },
  socioemotional_btn: {
    backgroundColor: '#EF7B8E',
    width: 360,
    height: 40,
    gap: 10,
    borderRadius: 8,
    '&:hover': {
      backgroundColor: '#EF7B8E'
    },
    fontSize: '16px',
    fontWeight: 600,
    textTransform: 'none',
    lineHeight: '19.5px',
    [theme.breakpoints.down('730')]: {
      width: 300,
      textAlign: 'center',
      fontWeight: 700,
      height: 50
    },
    [theme.breakpoints.down('400')]: {
      width: 250,
      height: 60
    }
  },
  text_section: {
    maxWidth: '30%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    '& .title': {
      margin: 0,
      color: '#4D5E80',
      marginBottom: 16,
      [theme.breakpoints.down('700')]: {
        textAlign: 'center'
      }
    },
    '& .subtitle': {
      margin: 0,
      color: '#666666',
      marginBottom: 32,
      [theme.breakpoints.down('700')]: {
        textAlign: 'center',
        fontWeight: 600
      }
    },
    [theme.breakpoints.down('1200')]: {
      maxWidth: '100%'
    }
  },
  options_wrapper: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    flexWrap: 'wrap',
    gap: 16,
    [theme.breakpoints.down('1025')]: {
      justifyContent: 'center'
    },
    [theme.breakpoints.down('818')]: {
      minWidth: 1400,
      padding: '0px 8px',
      flexWrap: 'nowrap',
      overflowX: 'auto',
      justifyContent: 'start',
      overflowY: 'hidden',
      alignItems: 'center',
      height: '240px',
      WebkitOverflowScrolling: 'touch'
    }
  },
  option: {
    width: 300,
    height: 210,
    display: 'flex',
    flexDirection: 'column',
    gap: 0,
    padding: '16px 24px',
    borderRadius: 16,
    transition: 'all 0.3s ease',
    justifyContent: 'center',
    '&:hover': {
      boxShadow: '0px 10px 18px -3px rgba(0,0,0,0.2)',
      transform: 'translateY(-5px)'
    },
    [theme.breakpoints.down('1824')]: {
      width: 270,
      padding: '18px 26px'
    },
    [theme.breakpoints.down('1724')]: {
      width: 250,
      padding: '18px 26px'
    },
    [theme.breakpoints.down('1600')]: {
      width: 225,
      height: 225,
      justifyContent: 'flex-start'
    },
    [theme.breakpoints.down('1498')]: {
      width: 210,
      height: 210
    },
    [theme.breakpoints.down('1423')]: {
      width: 200,
      height: 200
    },
    [theme.breakpoints.down('1374')]: {
      width: 190,
      height: 190
    },
    [theme.breakpoints.down('1324')]: {
      width: 180,
      height: 180
    },
    [theme.breakpoints.down('1280')]: {
      width: 290
    },
    [theme.breakpoints.down('912')]: {
      width: 280
    },
    [theme.breakpoints.down('821')]: {
      width: 270,
      height: 205,
      padding: '16px 24px'
    }
  },
  option_text: {
    display: 'flex',
    flexDirection: 'column',
    height: 75,
    '& .title': {
      fontWeight: 500,
      fontSize: 21,
      margin: 0,
      [theme.breakpoints.down('1600')]: {
        fontSize: 26
      },
      [theme.breakpoints.down('1374')]: {
        fontSize: 20
      },
      [theme.breakpoints.down('818')]: {
        fontSize: 25
      }
    },
    '& .count': {
      fontWeight: 600,
      fontSize: 40,
      margin: 0
    },
    '& .plus': {
      margin: 0
    }
  },
  white: {
    '& .title, .count, .plus': {
      color: '#FFFFFF'
    }
  },
  dark: {
    '& .title, .count, .plus': {
      color: '#555555'
    }
  }
}))

const HomePage = ({
  getThemes,
  getEvents,
  getEventsRSPA,
  getMessagesWithoutRoomRSPA,
  getHomepageOverviewRSPA,
  getEventComments,
  eventComments,
  cleanThemes,
  events,
  themes,
  getReportStudentsAnswers,
  reportAnswers,
  user,
  currentOccupation,
  fractalId,
  currentSchool,
  userId
}) => {
  // only school admin can access the homepage
  const isAdmin = currentOccupation?.includes(roles.SCHOOL_ADMIN)
  const isTeacher = currentOccupation?.includes(roles.TEACHER)
  const isNurse = currentOccupation?.includes(roles.NURSE)
  const isPsychologist = currentOccupation?.includes(roles.PSYCHOLOGIST)
  const classes = useStyles({ isTeacher, isNurse, isPsychologist })
  const history = useHistory()
  const [options, setOptions] = React.useState({
    items: [
      {
        key: 'active_classrooms',
        label: 'Turmas ativas',
        svg: homepageClassroomsSVG,
        backgroundColor: '#9DD2DA',
        fontTheme: 'dark',
        color: '#555555'
      },
      {
        key: 'contents',
        label: 'Conteúdos disponíveis',
        svg: homepageContentsSVG,
        backgroundColor: '#8B598E',
        fontTheme: 'white',
        color: '#ffffff'
      },
      {
        key: 'created_events',
        label: 'Comunicados criados',
        svg: homepageAnnouncementsSVG,
        backgroundColor: '#F4A87C',
        fontTheme: 'white',
        color: '#ffffff'
      },
      {
        key: 'received_messages',
        label: 'Total de mensagens',
        svg: homepageMessagesSVG,
        backgroundColor: '#386093',
        fontTheme: 'white',
        color: '#ffffff'
      },
      {
        key: 'total_events',
        label: 'Total de eventos',
        svg: homepageEventsSVG,
        backgroundColor: '#D2D5D8',
        fontTheme: 'dark',
        color: '#555555'
      },
      {
        key: 'created_reports',
        label: 'Diários gerados',
        svg: homepageReportsSVG,
        backgroundColor: '#555555',
        fontTheme: 'white',
        color: '#ffffff'
      }
    ],
    isFetching: false
  })

  const hasAccess = useHasAccess()

  React.useEffect(() => {
    setOptions(prev => ({ ...prev, isFetching: true }))
    getHomepageOverviewRSPA()
      .then(res => {
        setOptions(prev => ({
          ...prev,
          items: prev.items.map(option => {
            const updatedOption = {
              ...option,
              totalCount: res?.[option?.key]
            }
            if (option.key === 'received_messages') {
              updatedOption.plusInfo = res?.pending_messages
            }
            return updatedOption
          })
        }))
      })
      .finally(() => {
        setOptions(prev => ({ ...prev, isFetching: false }))
      })
  }, [])

  const handleSocioemotionalBtn = () => {
    history.push('/socioemotional')
  }

  return (
    <ContainerHomePage>
      <div className={classes.homepageGrid}>
        <div className={classes.welcomeUser}>
          <div className={classes.first_section}>
            <div className={classes.text_section}>
              <div className={classes.textContent}>
                <h1 className='title'>Bem-vindo(a) {user?.attributes?.name}</h1>
                <p className='subtitle'>
                  Transforme emoções em competências, engaje as famílias,
                  fortaleça a cultura e a performance acadêmica de sua escola.
                </p>
                {hasAccess(accessSocioemotional) && (
                  <Button
                    onClick={handleSocioemotionalBtn}
                    className={classes.socioemotional_btn}
                  >
                    Explorar os conteúdos do Versar
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>
        {hasAccess(accessSocioemotional) && (
          <div className={classes.exploringSocioemotional}>
            <SocioemotionalSlider
              history={history}
              getThemes={getThemes}
              themes={themes}
              cleanThemes={cleanThemes}
            />
          </div>
        )}
        <div className={classes.informationCards}>
          <div className={classes.options_wrapper}>
            {options.items.map((option, idx) => {
              return (
                <div
                  key={idx}
                  className={classes.option}
                  style={{ backgroundColor: option.backgroundColor }}
                >
                  <StyledSVG src={option.svg} width={48} height={48} />
                  <div
                    className={`${classes.option_text} ${
                      classes?.[option.fontTheme]
                    }`}
                  >
                    <h1 className='title'>{option.label}</h1>
                    {options.isFetching ? (
                      <CircularProgress
                        style={{ color: option.color }}
                        size={40}
                      />
                    ) : (
                      <p className='count'>
                        {option.totalCount === 0 ? '000' : option.totalCount}
                      </p>
                    )}
                    {option.plusInfo > 0 && (
                      <p className='plus'>{option.plusInfo} sem ler</p>
                    )}
                  </div>
                </div>
              )
            })}
          </div>
        </div>
        {!isTeacher && (
          <div className={classes.infirmary}>
            <InfirmarySlider
              currentSchool={currentSchool}
              userId={userId}
              history={history}
              reportAnswers={reportAnswers}
              getReportStudentsAnswers={getReportStudentsAnswers}
            />
          </div>
        )}
        {!isTeacher &&
          !isPsychologist &&
          !isNurse && (
            <div className={classes.latestComments}>
              <EventCommentSlider
                currentSchool={currentSchool}
                history={history}
                getEventComments={getEventComments}
                eventComments={eventComments}
              />
            </div>
          )}
        <div className={classes.latestMessages}>
          <LastMessagesSlider
            currentOccupation={currentOccupation}
            fractalId={fractalId}
            history={history}
            getMessagesWithoutRoomRSPA={getMessagesWithoutRoomRSPA}
          />
        </div>
        <div className={classes.digitalMural}>
          <EventsSlider
            getEventsRSPA={getEventsRSPA}
            history={history}
            isTeacher={isTeacher}
          />
        </div>
        <div className={classes.eventsCalendar}>
          <EventCalendar
            isAdmin={isAdmin}
            history={history}
            getEvents={getEvents}
            events={events}
          />
        </div>
      </div>
    </ContainerHomePage>
  )
}

const mapStateToProps = (state, props) => {
  return {
    events: state.events,
    themes: state.themes,
    reportAnswers: state.reports.reportAnswers,
    eventComments: state.events.comments,
    user: state.auth.user.data,
    userId: state.auth.user.data.id,
    currentOccupation: state.auth.currentOccupation,
    fractalId: state.auth?.user?.data?.attributes?.fractal_id,
    currentSchool: state.school.currentSchool.school
  }
}

const mapDispatchToProps = dispatch => ({
  getEvents: data => dispatch(getEvents(data)),
  getEventComments: data => dispatch(getEventComments(data)),
  getThemes: data => dispatch(newGetThemes(data)),
  cleanThemes: data => dispatch(newCleanThemes(data)),
  getReportStudentsAnswers: data => dispatch(getReportStudentsAnswers(data)),
  getEventsRSPA: data => dispatch(getEventsRSPA.request(data)),
  getMessagesWithoutRoomRSPA: data =>
    dispatch(getMessagesWithoutRoomRSPA.request(data)),
  getHomepageOverviewRSPA: data =>
    dispatch(getHomepageOverviewRSPA.request(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(HomePage)
